import { DAY_IN_SECONDS, SECOND_IN_MILLISECONDS } from '../../constants'

export const fromUnixTimestamp = (timestamp: number) => timestamp * SECOND_IN_MILLISECONDS
export const toUnixTimestamp = (timestamp: number) => timestamp / SECOND_IN_MILLISECONDS

export const subDays = (timestamp: number, days: number) => timestamp - days * DAY_IN_SECONDS * SECOND_IN_MILLISECONDS
